<template>
  <base-floating-card>
    <div id="event-add-contact-card">
      <div id="add-contact-art">
        <h5>Add Contact To Event</h5>
        <add-contact-svg class="art" />
      </div>
      <div id="search-components">
        <div id="inputs">
          <Input
            class="contact-input"
            heading="Email Address"
            @scs-input="emailInput"
          />
          <Input
            class="contact-input"
            heading="Phone Number"
            @scs-input="phoneNumberInput"
          />
          <Input
            class="contact-input"
            heading="First Name"
            @scs-input="firstNameInput"
          />
          <Input
            class="contact-input"
            heading="Last Name"
            @scs-input="lastNameInput"
          />
          <Select
            class="contact-input"
            heading="Role"
            :options="roles"
            titleProperty="display"
            @input="roleInput"
          />
        </div>
        <div id="contact-search-results">
          <contact-search-item
            v-if="chosenContact"
            :contact="chosenContact"
            :selected="true"
            @click="removeContact(chosenContact)"
          />
          <contact-search-item
            v-for="(contact, index) in searchedContacts"
            :key="index"
            :contact="contact"
            :selected="false"
            @click="selectOwnedContact(contact, index)"
          />
        </div>
        <div id="buttons">
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'x'"
            @click="close"
          />
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'checkmark'"
            @click="submitContact"
          />
        </div>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";
import ContactSearchItem from "../../ListItems/Contact/Search.vue";
import RoundButtonWithIcon from "../../RoundButtonWithIcon.vue";
import AddContactSvg from "../../Illustrations/AddContact.vue";
import Input from "../../../Elements/Input.vue";
import Select from "../../../Elements/Select.vue";
export default {
  data() {
    return {
      processing: false,
      art: require("../../Illustrations/AddContact.vue"),
      chosenContact: undefined,
      emailSearchTerm: undefined,
      firstName: undefined,
      lastName: undefined,
      phoneNumber: undefined,
      role: "client",
      roles: [
        {
          display: "Client",
          value: "client",
        },
        {
          display: "Employee",
          value: "employee",
        },
        {
          display: "Organizer",
          value: "organizer",
        },
        {
          display: "Vendor",
          value: "vendor",
        },
      ],
    };
  },
  computed: {
    searchedContacts() {
      return this.$store.getters.contacts
        .filter((x) => {
          if (this.emailSearchTerm) {
            return x.email
              ? x.email
                  .toLowerCase()
                  .includes(this.emailSearchTerm.toLowerCase())
              : false;
          } else {
            return true;
          }
        })
        .filter((x) => {
          if (this.chosenContact) {
            return x.userId !== this.chosenContact.userId;
          } else {
            return true;
          }
        })
        .slice(0, 2);
    },
  },
  methods: {
    async emailInput(value) {
      this.emailSearchTerm = value;
    },
    firstNameInput(value) {
      this.firstName = value;
    },
    lastNameInput(value) {
      this.lastName = value;
    },
    phoneNumberInput(value) {
      this.phoneNumber = value;
    },
    roleInput(role) {
      this.role = role.value;
    },
    removeContact() {
      if (this.chosenContact.source === "db") {
        this.ownedContacts.unshift(this.chosenContact);
      } else {
        this.cognitoSearch.unshift(this.chosenContact);
      }
    },
    selectOwnedContact(contact) {
      contact.source = "db";
      this.chosenContact = contact;
    },
    async submitContact() {
      this.processing = true;
      let contact;
      if (this.chosenContact) {
        contact = this.chosenContact;
      } else {
        contact = {
          given_name: this.firstName,
          family_name: this.lastName,
          email: this.emailSearchTerm,
          phoneNumber: this.phoneNumber,
        };
      }
      let payload = {
        contact: contact,
        role: this.role,
        eventKey: {
          userId: this.event.userId,
          tenantId: this.event.tenantId,
        },
      };
      await this.$store.dispatch("addContactToEvent", payload);
      this.processing = false;
      this.close();
    },
    close() {
      this.$emit("close");
    },
  },
  components: {
    BaseFloatingCard,
    ContactSearchItem,
    RoundButtonWithIcon,
    Input,
    Select,
    AddContactSvg,
  },
  props: ["event"],
};
</script>
<style scoped>
@media screen {
  #event-add-contact-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
  }

  #add-contact-art {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  #add-contact-art > h5 {
    margin: 0;
  }
  .art {
    width: 100px;
  }
  #search-components {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  #inputs {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }

  .contact-input {
    width: 100%;
    margin: 5px;
  }

  #contact-search-results {
    padding: 20px 5px;
    box-sizing: border-box;
    max-height: 200px;
    overflow: scroll;
  }

  #buttons {
    display: flex;
    width: 100px;
    padding: 10px;
    justify-content: space-between;
  }
  @media (min-width: 600px) {
    #event-add-contact-card {
      flex-direction: row;
    }

    #add-contact-art {
      width: 40%;
    }
    #search-components {
      width: 60%;
    }

    #inputs {
      flex-direction: row;
    }

    .contact-input {
      width: 40%;
    }
  }
}
</style>
